import Api from "./api";
import LocalStorage from "./local-storage";
import $ from 'cash-dom';
import Auth from './auth';
import * as helper from './helper';
import * as utils from './utils';
import Html from "./html";
import Mission from "./mission";
import {
    createSound
} from './sound';
// import * as sound from './sound';
import * as form from './form';
import Reward from './reward';
import Cookie from './cookie';
import Quiz from "./quiz";


export default class WoayClient {
    constructor(Options, eventBus, soundObj) {
        this._userInfo = {};
        this.Options = Options;
        this.Wheel = Options.Wheel;
        this.SETTINGS = Options.SETTINGS;
        this.api = new Api(this.Wheel);
        this.eventBus = eventBus;
        this.mission = new Mission(this.api, this.eventBus);
        this.quiz = new Quiz(this.api, this.eventBus);
        this.html = new Html(this.eventBus);
        this.local = new LocalStorage(this.Wheel);
        this.cookie = new Cookie(this.Wheel);
        this.helper = helper;
        this.checkError = this.helper.checkErrorFactory(this.html, this.local, SETTINGS);
        this.reward = new Reward(Options, this.api, this.eventBus, this._userInfo, this.html, this.checkError);
        this.auth = new Auth(Options, this.html, this.api, this.local, this.checkError);
        this.utils = utils;
        this.form = form;
        // Don't manage sound if the 3rd arg is false
        if (soundObj !== false) {
            this.sound = createSound(Options, soundObj);
        }
    }

    async verifyLoginDone(data) {
        if (!data.jwt) {
            throw 'Dữ liệu đăng nhập không hợp lệ';
        }
        console.log('data', data);
        console.log('this verifyLoginDone', this);
        this.api.http.setToken(data.jwt);
        console.log('hasLogin', this.reward.hasLogin);
        if (this.reward.hasLogin) return;
        this.reward.hasLogin = true;
        this._userInfo = data;
        await Promise.all([this.reward.fetchRewards(), this.reward.updateTurn()]);
        this.reward.updateTurnCount();
        if (!this.reward.isOutOfTurn()) {
            await this.reward.claimReward();
        }
        if (this.SETTINGS.button_group_index_1 && this.SETTINGS.button_group_index_1.active) {
            $('.btn-check-reward').css('display', 'block');
        }
        this.eventBus.emit('login-done');
        console.log('update success verify');
    }

    updateInfoAfterLogin(data) {
        // console.log('updateInfoAfterLogin', this);
        this.updatePlayerInfo(data)
            .then(data => {
                if (!data) return;
                // console.log('data', data.jwt);
                this.setUserInfo(data);
            })
        this.html.closeAllModal();
    }

    async updatePlayerInfo(data) {
        try {
            var finalData = await this.api.updatePlayerInfo(data)
            console.log('finalData', finalData);
            return finalData;
        } catch (e) {
            this.checkError(e);
        }
    }

    getUserInfo() {
        return JSON.parse(JSON.stringify(this._userInfo));
    }

    setUserInfo(info) {
        console.log('setUserInfo');
        Object.assign(this._userInfo, info);
        if (!this._userInfo.name) {
            this._userInfo.name = 'anonymous';
        }
        const uInfo = JSON.parse(JSON.stringify(this._userInfo));
        this.local.set('userInfo', uInfo, 7);
        this.local.set('wauth', uInfo.jwt, 7);
        return this._userInfo;
    }
}

// window.WoayClient = WoayClient;